var Highcharts = require('highcharts/highcharts');

export class EnrollmentPage {
    siteScoreTreatment: any;
    formCompletions: any;
    raceData: any;
    ethnicData: any;
    constructor(raceData: any, ethnicData: any, siteNames: any, siteEnrollmentData: any, siteScoringData:any, siteSelection: any, formCompletes: any) {
        this.siteScoreTreatment = siteScoringData;
        this.formCompletions = formCompletes;
        this.raceData = raceData;
        this.ethnicData = ethnicData;

        $(() => {
            var page = this;
            let siteSelect = $('#selSite');
            siteSelect.empty();
            siteSelect.append('<option value="-1" selected="true">All Sites</option>');

            $.each(siteSelection, function (Id: string, Obj: any) {
                siteSelect.append($('<option></option>').attr('value', Obj.Id).text(Obj.Name))
            });

            Highcharts.setOptions({
                colors: ['#532565', '#982568', '#981f32', '#bf362e', '#e07c3e', '#818a91', '#dddddd']
            });

    //        Highcharts.chart('obsEnrollment', {
    //            chart: {
    //                plotBackgroundColor: null,
    //                plotBorderWidth: null,
    //                plotShadow: false,
    //                type: 'pie',
    //                styledMode: false
    //            },
    //            title: {
    //                text: ''
    //            },
    //            tooltip: {
    //                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    //            },
    //            accessibility: {
    //                point: {
    //                    valueSuffix: '%'
    //                }
    //            },
    //            plotOptions: {
    //                pie: {
    //                    allowPointSelect: true,
    //                    cursor: 'pointer',
                
    //                    dataLabels: {
    //                        enabled: true,
    //                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
    //                    }
    //                }
    //            },
    //            series: [{
    //                name: "Period",
    //                colorByPoint: true,
    //                data: enrollmentData
				//}]
                    
    //        });

            Highcharts.chart('obsEnrollBySite', {
                chart: {
                    type: 'bar',
                    marginLeft: 250,
                    marginBottom: 90
                },
                title: {
                    text: ''
                },
                xAxis: {
                    width: 300,
                    categories: siteNames
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        stacking: 'normal'
                    }
                },

                series: siteEnrollmentData
            });

            var treatmentChart = Highcharts.chart('obsScoreTreatment', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: [
                        '01/01/22-03/31/22',
                        '10/01/19-12/31/19',
                        '10/01/21-12/31/21',
                        '07/01/21-09/30/21'
                        
                        
                    ],
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    units: 'Subject Count'
                },
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: this.filterScoringTreatment(-1)
            });

            var completionsChart = Highcharts.chart('obsFormCompletions', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: [
                        'Site Survey',
                        'Provider Survey'
                    ],
                    crosshair: true
                },
                yAxis: {
                    min: 0
                },
                legend: {
                    enabled: false
				},
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.0f} surveys</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: [{
                    name: "Completions",
                    data: this.filterFormCompletions(-1)
                }]
            });

            siteSelect.on('change', function () {
                let sel: string = <string>$('#selSite').val();
                let site = parseInt(sel);
                let seriesData = page.filterScoringTreatment(site);
                treatmentChart.series[0].update(seriesData[0]);
                treatmentChart.series[1].update(seriesData[1]);
                treatmentChart.redraw();

                let completionsData = page.filterFormCompletions(site);
                completionsChart.series[0].update({ name: "Completions", data: completionsData });
                completionsChart.redraw();

                let raceData = page.filterRaceData(site);
                raceChart.series[0].update({name: "Race", data: raceData});
                raceChart.redraw();

                let ethnicData = page.filterEthnicData(site);
                ethnicChart.series[0].update({ name: "Ethnicity", data: ethnicData });
                ethnicChart.redraw();
            });
        });

        var raceChart = Highcharts.chart('obsRace', {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    styledMode: false
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
            },
            credits: {
                enabled: false
            },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',

                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                        }
                    }
                },
                series: [{
                    name: "Race",
                    colorByPoint: true,
                    data: this.filterRaceData(-1)
				}]

        });

        var ethnicChart = Highcharts.chart('obsEthnic', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                styledMode: false
            },
            title: {
                text: ''
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',

                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
                name: "Ethnicity",
                colorByPoint: true,
                data: this.filterEthnicData(-1)
            }]

        });
    }

    filterEthnicData(site: number) {
        var ethnicities = [{
            name: "Hispanic or Latino",
            y: 0
        },
        {
            name: "Not Hispanic or Latino",
            y: 0
        },
        {
            name: "Unknown or not reported",
            y: 0
            }];

        this.ethnicData.forEach(function (entry) {
            if (site <= 0) {
                for (let i = 0; i < 3; i++) {
                    ethnicities[i].y += entry.Ethnicities[i];
                }
            }
            else if (site == entry.Site) {
                for (let i = 0; i < 3; i++) {
                    ethnicities[i].y += entry.Ethnicities[i];
                }
            }
        });

        return ethnicities;
	}

    filterRaceData(site: number) {
        var races = [{
            name: "Black",
            y: 0
        },
        {
            name: "American Indian or Alaskan Native",
            y: 0

        },
        {
            name: "Native Hawaiian or Other Pacific Islander",
            y: 0
        },
        {
            name: "White",
            y: 0
        },
        {
            name: "Asian",
            y: 0
        },
        {
            name: "Unknown or not reported",
            y: 0
        },
        {
            name: "More than one race",
            y: 0
        }];

        this.raceData.forEach(function (entry) {
            if (site <= 0) {
                for (let i = 0; i < 7; i++) {
                    races[i].y += entry.Races[i];
                }
            }
            else if (site == entry.Site) {
                for (let i = 0; i < 7; i++) {
                    races[i].y += entry.Races[i];
                }
			}
        });

        // hide races with 0 values, make it cleaner
        for (let i = 6; i >= 0; i--) {
            if (races[i].y == 0)
                races.splice(i, 1);
		}

        return races;
	}

    filterScoringTreatment(site: number) {
        // output needs to be:
        // name: Pharmacologic Treatment or No Pharmacological Treatment
        // data: [sum of period 1, sum of period 2]
        var output1 =
        {
            name: "Pharmacologic Treatment",
            data: [0, 0, 0, 0]
        };

        var output2 =
        {
            name: "No Pharmacological Treatment",
            data: [0, 0, 0, 0]
		}
        
        this.siteScoreTreatment.forEach(function (entry) {
            if (site <= 0) {
                if (entry.treatment == '1') // yes treatment
                {
                   output1.data[entry.period - 1] += 1;
                }
                else {
                    output2.data[entry.period - 1] += 1;
				}
            }
            else {
                if (entry.site == site) {
                    if (entry.treatment == '1') // yes treatment
                    {
                        output1.data[entry.period - 1] += 1;
                    }
                    else {
                        output2.data[entry.period - 1] += 1;
                    }
				}
			}
        });

        return [output1, output2];
    }

    filterFormCompletions(site: number) {
        var siteSurvey = 0;
        var providerSurvey = 0;


        this.formCompletions.forEach(function (entry) {
            if (site <= 0) {
                siteSurvey += entry.SiteSurvey;
                providerSurvey += entry.ProviderSurvey;
            }
            else {
                if (site == entry.Site) {
                    siteSurvey += entry.SiteSurvey;
                    providerSurvey += entry.ProviderSurvey;
				}
			}
        });

        return [siteSurvey, providerSurvey];

	}


}